module.exports = __webpack_public_path__ + "img/prize-01.ab63293d.png";